var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5C5 8.08579 5.33579 7.75 5.75 7.75H9C9.41421 7.75 9.75 8.08579 9.75 8.5C9.75 8.91421 9.41421 9.25 9 9.25H5.75C5.33579 9.25 5 8.91421 5 8.5Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5C5 11.0858 5.33579 10.75 5.75 10.75H9C9.41421 10.75 9.75 11.0858 9.75 11.5C9.75 11.9142 9.41421 12.25 9 12.25H5.75C5.33579 12.25 5 11.9142 5 11.5Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13.75C5.33579 13.75 5 14.0858 5 14.5C5 14.9142 5.33579 15.25 5.75 15.25H9C9.41421 15.25 9.75 14.9142 9.75 14.5C9.75 14.0858 9.41421 13.75 9 13.75H5.75Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.5C14.25 8.08579 14.5858 7.75 15 7.75H18.25C18.6642 7.75 19 8.08579 19 8.5C19 8.91421 18.6642 9.25 18.25 9.25H15C14.5858 9.25 14.25 8.91421 14.25 8.5Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.75C14.5858 10.75 14.25 11.0858 14.25 11.5C14.25 11.9142 14.5858 12.25 15 12.25H18.25C18.6642 12.25 19 11.9142 19 11.5C19 11.0858 18.6642 10.75 18.25 10.75H15Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.5C14.25 14.0858 14.5858 13.75 15 13.75H18.25C18.6642 13.75 19 14.0858 19 14.5C19 14.9142 18.6642 15.25 18.25 15.25H15C14.5858 15.25 14.25 14.9142 14.25 14.5Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4C2.7835 4 2 4.7835 2 5.75V17.25C2 18.2165 2.7835 19 3.75 19H9.52786C9.72192 19 9.91331 19.0452 10.0869 19.132L11.6646 19.9208C11.8757 20.0264 12.1243 20.0264 12.3354 19.9208L13.9131 19.132C14.0867 19.0452 14.2781 19 14.4721 19H20.25C21.2165 19 22 18.2165 22 17.25V5.75C22 4.7835 21.2165 4 20.25 4H14C13.212 4 12.5014 4.33145 12 4.86253C11.4986 4.33145 10.788 4 10 4H3.75ZM10 5.5C10.6904 5.5 11.25 6.05964 11.25 6.75V18.0365L10.7577 17.7903C10.3758 17.5994 9.95479 17.5 9.52786 17.5H3.75C3.61193 17.5 3.5 17.3881 3.5 17.25V5.75C3.5 5.61193 3.61193 5.5 3.75 5.5H10ZM13.2423 17.7903L12.75 18.0365V6.75C12.75 6.05964 13.3096 5.5 14 5.5H20.25C20.3881 5.5 20.5 5.61193 20.5 5.75V17.25C20.5 17.3881 20.3881 17.5 20.25 17.5H14.4721C14.0452 17.5 13.6242 17.5994 13.2423 17.7903Z",
    fill: "white",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen24Line);
export default __webpack_public_path__ + "static/media/Book-Open-24-line.235630d993f477450ab6527afa9a0abc.svg";
export { ForwardRef as ReactComponent };